<div class="card fields-dashboard-configurable" *ngIf="equipment">
  <div class="card-header">
    <div class="card-header-title my-2">
      <lib-terminal-header [equipment]="equipment"
        [link]="'/farming/'+equipment.serialNumber+'/configurable'"
        [showStatusIcon]="true"
        [connected]="Number(equipment.connected)"
        [irrigating]="isIrrigating(equipment)"
      ></lib-terminal-header>
    </div>
  </div>
  <div class="card-body">
    <app-configurable-states
      [equipment]="equipment"
      [terminal]="terminal"
    ></app-configurable-states>

    <app-configurable-water-system
      [equipment]="equipment"
      [class]="'mb-4'"
    >
    </app-configurable-water-system>
    <div class="alert alert-light" *ngIf="!equipment.states || !equipment.states.programs || equipment.states.programs.length === 0; else withProgramsState">
      {{ 'configurable_no_program_states' | translation }}
    </div>

    <ng-template #withProgramsState>
      <app-terminal-table-wrapper
        [data]="equipment.states.programs"
        [name]="'configurable_programs'"
        [searchPlaceholder]="'configurable_name' | translation"
        [isFetchingData]="false"
        [tableHeaders]="[
          ('configurable_name' | translation),
          ('configurable_status' | translation),
          ('configurable_group' | translation),
          ('configurable_phase' | translation),
          ('configurable_time' | translation),
          ('configurable_activations' | translation)
        ]"
        type="configurable"
      >
        <tr class="row-pointer"
          *appTerminalTableData="let prog"
          [routerLink]="[
            '/farming',
            equipment.serialNumber,
            'configurable',
            'program',
            prog.program,
            'group',
            0
          ]"
        >
          <td class="terminal-table-data">
            {{ prog.name }}
          </td>
          <td class="terminal-table-data">
            <span class="badge"
                  *ngIf="prog.program !== undefined"
                  [class]="prog.state | badgeClass : 'CONFIGURABLE'"
            >
              {{ prog !== undefined
                ? ('configurable_state_'+prog?.state | translation)
                : '' }}
            </span>
          </td>
          <td class="terminal-table-data">
            {{ prog.state === 'IRRIGATING' ? prog.actualGroup + 1 : '' }}
          </td>
          <td class="terminal-table-data">
            {{ getPhaseLabel(prog.actualPhase) }}
          </td>
          <td class="terminal-table-data">
            {{ prog.actualTime * 1000 | date:'HH:mm:ss':'UTC' }}
            /
            {{ prog.todayTime * 1000 | date:'HH:mm:ss':'UTC' }}
          </td>
          <td class="terminal-table-data">
            {{ prog.activations }}
          </td>
        </tr>
      </app-terminal-table-wrapper>
    </ng-template>

  </div>
</div>

<div class="card fields-dashboard-configurable" *ngIf="!equipment && terminal">
  <div class="card-header">
    <div class="card-header-title my-2">
      <lib-terminal-header
        [equipment]="terminal"
        [link]="'/farming/' + terminal.vid + '/configurable'"
        [showStatusIcon]="true"
        [connected]="terminal.enabled === TERMINAL_ENABLED_TEMPORARY_DISABLED ? 2 : 0"
      ></lib-terminal-header>
    </div>
  </div>
  <div class="row my-4 mx-2" *ngIf="terminal.enabled !== TERMINAL_ENABLED_TEMPORARY_DISABLED">
    <i>{{ 'no_results' | translation }}</i>
  </div>
  <div class="row mx-2" *ngIf="terminal.enabled === TERMINAL_ENABLED_TEMPORARY_DISABLED">
    <app-terminal-placeholder-data
      [terminalType]="'configurable'"
      [size]="'small'">
    </app-terminal-placeholder-data>
  </div>
</div>
